import React from "react";

function Input({ label, error, ...rest }) {
  const isTextArea = rest.type === "textarea";
  const inputClasses = ["ms-input"];
  if (error) inputClasses.push("is-invalid");

  const errorId = error && rest.name ? `${rest.name}-error` : undefined;
  const a11y = error ? { "aria-invalid": true, "aria-describedby": errorId } : {};
  const inputElement = isTextArea ? (
    <textarea className={inputClasses.join(" ")} id={rest.name} {...a11y} {...rest}></textarea>
  ) : (
    <input className={inputClasses.join(" ")} id={rest.name} {...a11y} {...rest} />
  );

  return (
    <div className="w-100 mb-3">
      {label && (
        <label htmlFor={rest.name} className="ms-label">
          {label}
          {rest.required ? <span className="text-danger-ms mis-1-ms">*</span> : null}
        </label>
      )}
      {inputElement}
      {error && <div className="ms-error" id={errorId} role="alert">{error}</div>}
    </div>
  );
}

export default Input;
